import { learningServiceRequest } from "./utils";

const entityVisibilityService = {
  async isBlocked(entityId, productId) {
    return await learningServiceRequest({
      method: "get",
      url: `/entity_program_visibility/`,
      params: {
        entity_id: entityId,
        product_id: productId,
      },
    });
  },

  async optIn(entityId, productIds) {
    return await learningServiceRequest({
      method: "delete",
      url: `/entity_program_visibility/bulk_delete/`,
      payload: {
        entity_id: entityId,
        product_ids: productIds,
      },
    });
  },

  async optOut(data) {
    return await learningServiceRequest({
      method: "post",
      url: `/entity_program_visibility/bulk_create/`,
      payload: {
        items: data,
      },
    });
  },

  /**
   * 🚨 WARNING: HIGHLY DESTRUCTIVE 🚨
   * This endpoint performs bulk updates or DELETION of visibility records.
   * It is to be used ONLY on the Brand Settings page
   *
   * Visibility record management depends on the reset_visibility_rules flag:
   * - If reset_visibility_rules=True and exclude_public_content=True:
   *  Upserts visibility records for all marketplace program_pages and sessions
   *  - If reset_visibility_rules=True and exclude_public_content=False:
   *  Deletes all existing entity_program_visibility records
   * - If reset_visibility_rules=False:
   *  No changes to visibility records (only updates exclude_public_content)
   *
   * @param {string} entity_id The entity ID to update.
   * @param {object} data The payload containing control flags.
   * @param {boolean} data.reset_visibility_rules Controls whether to modify existing visibility records.
   * @param {boolean} data.exclude_public_content Sets the entity's public content exclusion preference.
   **/
  async resetVisibilityRules(entity_id, data) {
    return await learningServiceRequest({
      method: "post",
      url: `/entity_program_visibility/${entity_id}/reset_visibility_rules/`,
      payload: data,
    });
  },
};

export default entityVisibilityService;
